import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

export default WithDirection(styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    // -- First line
    .app-score { display: flex; flex-direction: column; align-items: center; }

    .app-score small {
        font-family: 'Montserrat';
        font-size: 16px;
        color: rgba(12, 183, 148, 1);
        text-align: left;
        letter-spacing: 0.09em;
    }
    .app-score small + * {
        font-family: 'Montserrat';
        font-size: 30px;
        color: rgba(12, 183, 148, 1);
        text-align: left;
        letter-spacing: 0.2em;
    }

    // -- Second line
    .app-header-controls { margin-top: 21px; display: flex; justify-content: flex-end; }

    .flag-border-wrapper {
        display: block;
        border: 1px solid rgba(151, 151, 151, 1);
        width: 115px;
        padding: 8px 24px;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 20px;

        .flag-select, .selected--flag--option { display: block; margin: 0; padding: 0; }

        .selected--flag--option { display: flex; justify-content: center; align-items: center; }

        .country-flag {
            display:flex;
            align-items: center;
            width: auto !important;
            height: 24px !important;
            min-width: 65px;
        }
        .country-flag img { top: unset; width: auto; height: 24px; }

        .arrow-down { height: 24px; padding-top: 0; }

        .flag-options { left: -30%; right: -30%; max-height: unset; }
        .flag-select .flag-option.has-label { width: 100%; padding: 0; }
        .flag-select .flag-option.has-label .country-flag { justify-content: center; align-items: center; height: auto !important; padding: 4px 7px; }
        .flag-select .flag-option img + span { padding: 0; padding-left: 7px; }
    }

    @media screen and (max-width: 767px) {
        flex-direction: row;
        justify-content: space-between;
        flex-grow: 1;

        .app-score small { font-size: 12px; }
        .app-header-controls { margin-top: 0; }
    }
`);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/AppScore/Wrapper.js